<template>
  <div class="w-[100vw] h-[100vh] flex flex-col"
       style="background-image: url('/pulse_stripe_color.svg'); background-position: -20vw center; background-repeat: repeat-x; background-color: rgba(71,181,144,0.06)">
    <div class="h-8" style="app-region: drag;"></div>
    <div class="flex-1 p-8 flex flex-col-reverse items-center justify-center">
      <div>
        <AppAlert
          v-if="loginFailed"
          type="error"
        >
          Loginpoging mislukt. Controleer uw gebruikersnaam en wachtwoord.
        </AppAlert>
      </div>
      <div
        class="flex flex-row-reverse flex-wrap rounded-xl shadow-xl w-full max-w-sm sm:max-w-md overflow-hidden justify-between"
      >
        <FormKit
          ref="form"
          v-model="credentials"
          form-class="displayContents"
          type="form"
          :disabled="isSubmitting"
          :actions="false"
          @submit="attemptLogin"
        >
          <div class="bg-white bg-opacity-60 backdrop-blur-sm p-8 flex flex-col grow">
            <div class="mb-8 object-fit text-3xl font-bold inline-flex gap-3 items-center">
              <img class="object-fit" src="/pulse_logo.svg" alt="">
            </div>
            <FormKit
              type="text"
              name="username"
              label="Gebruikersnaam"
            />
            <FormKit
              id="password"
              type="password"
              name="password"
              label="Wachtwoord"
              @keyup.enter="attemptLogin"
            />

            <FormKit
              v-show="mfaRequired"
              ref="mfaCodeInput"
              type="text"
              name="mfaCode"
              label="Authenticator code"
              input-class="mfa-code-input"
              @keyup.enter="attemptLogin"
            />
            <AppButton
              class="ml-auto overflow-hidden"
              :disabled="isSubmitting"
              @click="attemptLogin"
            >
              <Transition
                name="slide-right-to-left"
                mode="out-in"
              >
                <AppIcon v-if="loginWasSuccess" icon="fa-lock-open"></AppIcon>
                <AppIcon v-else-if="!loginWasSuccess" icon="fa-lock"></AppIcon>
              </Transition>
              Inloggen
            </AppButton>
          </div>
        </FormKit>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { login } from "@q-food/q-food";
import { useAppStore } from "~/stores/App";
import { useUserStore } from "~stores/User";

const buildVersion = __APP_BUILD_VERSION__;

const mfaCodeInput = ref();
const { setToken } = useUserStore();
const { warning } = useToast();
const mfaRequired = ref(false);

const loginWasSuccess = ref(false);
const isSubmitting = ref(false);
const lockIconClass = ref("");

const credentials = ref({
	username: "",
	password: "",
	mfaCode: null as string | null,
});

const loginFailed = ref(false);

async function attemptLogin() {
	isSubmitting.value = true;
	loginFailed.value = false;

	login(credentials.value)
		.then((response) => {
			loginWasSuccess.value = true;
			setTimeout(async () => {
				await setToken(response.sessionId);
				await useAppStore().refreshApp();
			}, 750);
		})
		.catch((response) => {
			if (response.status == 428) {
				if (mfaRequired.value) {
					warning("2FA token niet geldig");
				} else {
					mfaRequired.value = true;
				}
				setTimeout(() => {
					document.querySelector<HTMLInputElement>("input.mfa-code-input")!.focus();
				}, 200);
			} else {
				loginFailed.value = true;
				lockIconClass.value = "shake";
				setTimeout(() => {
					lockIconClass.value = "";
				}, 1000);
			}
		})
		.finally(() => {
			isSubmitting.value = false;
		});
}
</script>

<style scoped>
.displayContents {
  @apply contents;
}

.shake {
  /* also need animation and -moz-animation */
  -webkit-animation: shake 0.5s linear;
}

@-webkit-keyframes shake {
  8%,
  41% {
    -webkit-transform: translateX(-10px);
  }
  25%,
  58% {
    -webkit-transform: translateX(10px);
  }
  75% {
    -webkit-transform: translateX(-5px);
  }
  92% {
    -webkit-transform: translateX(5px);
  }
  0%,
  100% {
    -webkit-transform: translateX(0);
  }
}
</style>
